export const InitialState = {
    candidateProfile: '',
    candidateStatus: '',
    candidateJobsApplied: '',
    candidateUploadedDocs: '',
    candidateInfo: '',
    loginDetails: '',
    logoutDetails: '',
    openPositions: '',
    documentTypes: '',
    jobDetails: '',
    notification: '',
    docUploadProgress: '',
};
